import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import '@n8n/chat/style.css';
import { createChat } from '@n8n/chat';

/**
 * n8n Chat Widget – Einbindung gemäß offizieller @n8n/chat Dokumentation.
 * Siehe: https://www.npmjs.com/package/@n8n/chat
 */
@Component({
  selector: 'app-n8n-chat',
  templateUrl: './n8n-chat.component.html',
  styleUrls: ['./n8n-chat.component.css']
})
export class N8nChatComponent implements AfterViewInit, OnDestroy {
  private chatInstance: unknown = null;

  ngAfterViewInit(): void {
    this.initChat();
  }

  ngOnDestroy(): void {
    const el = document.getElementById('n8n-chat');
    if (el) {
      el.innerHTML = '';
    }
    this.chatInstance = null;
  }

  private initChat(): void {
    const webhookUrl = environment.n8nWebhookUrl;
    if (!webhookUrl) {
      console.error('n8nWebhookUrl ist nicht definiert.');
      return;
    }

    this.chatInstance = createChat({
      webhookUrl,
      target: '#n8n-chat',
      mode: 'window',
      showWelcomeScreen: true,
      loadPreviousSession: true,
      enableStreaming: false,
      defaultLanguage: 'en',
      i18n: {
        en: {
          title: 'Support',
          subtitle: 'Wie können wir helfen?',
          footer: '',
          getStarted: 'Neue Unterhaltung',
          inputPlaceholder: 'Nachricht eingeben...',
          closeButtonTooltip: 'Chat schließen',
        },
      },
      initialMessages: ['Hallo! 👋', 'Wie kann ich Ihnen helfen?'],
    });
  }
}
